import React, { useEffect, useState } from "react";
import {
  Backdrop,
  Box,
  CircularProgress,
  CssBaseline,
  Grid,
} from "@mui/material";
import { GeoPoint } from "firebase/firestore";

import {
  images,
  mainLayoutStyles,
  showNotification,
} from "../../../../constants";
import Sidebar from "../../../../common/Sidebar";
import ImagePreviewModal from "../../../../common/ImagePreviewModal";
import OrgProfDataFieldsSection from "../../components/AlbumDetailsDataFieldsSection/OrgProfDataFieldsSection";
import DetailsPageHeader from "../../../../common/DetailsPageHeader";
import { useOrganizationContext } from "../../../../providers/OrganizationAdmin/OrganizationProvider";
import {
  updateOrganization,
  uploadOrgImageToStorage,
  checkOrgHandleAvailability,
  normalizeHandle,
} from "../../hook/Organizationhook";
import { Toast } from "../../../../common/alert";
import { useAuth } from "../../../../hooks";

const OrgProfContainer = () => {
  const { currentUser } = useAuth();
  const { currentOrganization, setLoading, loading, handleGetOrganization } =
    useOrganizationContext();

  const [imagePreviewModal, setImagePreviewModal] = useState(false);
  const [editEnabled, setEditEnabled] = useState(false);
  const [uploadImage, setUploadImage] = useState(null);
  const [selectedImageType, setSelectedImageType] = useState(null);

  useEffect(() => {
    handleGetOrganization();
  }, []);
  // useEffect(() => {
  //   if (Object.keys(currentOrganization).length === 0) {
  //     handleGetOrganization();
  //   }
  // }, [currentOrganization]); 

  const handleImagePreviewModalOpen = (imageType = 'logo') => {
    setSelectedImageType(imageType);
    setImagePreviewModal(true);
  };

  const handleImagePreviewModalClose = () => {
    setImagePreviewModal(false);
  };

  const handleUpdateOrganization = async () => {
    let keepEditing = false;
    try {
      setLoading(true);
      // Org handles must be unique across org handles AND usernames.
      const handleCheck = await checkOrgHandleAvailability(
        currentOrganization?.handle,
        { excludeOrgId: currentOrganization?.id }
      );
      if (!handleCheck.available) {
        Toast("error", handleCheck.message);
        keepEditing = true;
        return;
      }
      let dataTemp = {
        name: currentOrganization?.name ?? "",
        handle: normalizeHandle(currentOrganization?.handle),
        link: currentOrganization?.link ? currentOrganization?.link : "",
        description: currentOrganization?.description ?? "",
        updatedAt: new Date(),
        updatedBy: currentUser?.id,
        location: currentOrganization?.location || "",
        // Persist the user-editable "Display Location" field (used throughout the app UI)
        locationDisplay: currentOrganization?.locationDisplay || "",
        locationCountry: currentOrganization?.locationCountry || "",
        coordinates: new GeoPoint(
          currentOrganization?.coordinates?._lat || 0,
          currentOrganization?.coordinates?._long || 0
        ),
        g: {
          geohash: currentOrganization?.g?.geohash || "",
          geopoint: new GeoPoint(
            currentOrganization?.coordinates?._lat || 0,
            currentOrganization?.coordinates?._long || 0
          ),
        },
        allowAR: currentOrganization?.allowAR ?? false,
        autoApproveAR: currentOrganization?.autoApproveAR ?? false,
        importBatchAutoApprove:
          currentOrganization?.importBatchAutoApprove ?? false,
        quickCollectAutoApprove:
          currentOrganization?.quickCollectAutoApprove ?? false,
        createAreaStatusDefault:
          currentOrganization?.createAreaStatusDefault === "Inactive"
            ? "Inactive"
            : "Active",
      };
      if (uploadImage != null) {
        let photoUrl = await uploadOrgImageToStorage(uploadImage?.raw);
        dataTemp.logoOP = photoUrl;
        dataTemp.originalPhotoNameOP = uploadImage?.raw?.name;
      }
      console.log("data:", dataTemp);
      let responseTemp = await updateOrganization(
        currentOrganization.id,
        dataTemp
      );
      // console.log("update response:", responseTemp);
      showNotification("Organization updated successfully.");
      // Toast("success", "Organization updated successfully.");
    } catch (error) {
      Toast("error", error.message);
      console.log("error updating Organization", error.message);
    } finally {
      setLoading(false);
      if (!keepEditing) setEditEnabled(false);
    }
  };

  const handlePageLoadingClose = () => {
    setLoading(false);
  };

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <DetailsPageHeader
        mainTitle={"Organization Profile"}
        bgColor="#fff"
        buttonText={
          currentUser?.role === "super"
            ? "Edit"
            : currentUser?.role === "moderator" &&
              currentUser?.type === "general"
            ? "Edit"
            : undefined
        }
        editEnabled={editEnabled}
        setEditEnabled={setEditEnabled}
        cancelButton={editEnabled ? true : false}
        handleSave={() => handleUpdateOrganization()}
        loading={loading}
      />
      <Sidebar />
      <Grid
        container
        style={{ ...mainLayoutStyles, background: "#fff", paddingTop: 80 }}
      >
        <Grid container direction={"column"}>
          <OrgProfDataFieldsSection
            handleImagePreviewModalOpen={handleImagePreviewModalOpen}
            editEnabled={editEnabled}
            uploadImage={uploadImage}
            setUploadImage={setUploadImage}
            setEditEnabled={setEditEnabled}
          />
        </Grid>
      </Grid>

      <ImagePreviewModal
        modalOpen={imagePreviewModal}
        handleClose={handleImagePreviewModalClose}
        image={
          uploadImage != null && uploadImage.preview
            ? uploadImage.preview
            : currentOrganization?.logoOP
        }
        imageOP={null}
      />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
        onClick={handlePageLoadingClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </Box>
  );
};

export default OrgProfContainer;
